import React, { useState } from 'react';
import './style.scss'
import { FilePond, registerPlugin } from 'react-filepond';

import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);
function ImageUpload(props) {
  const [pond, setPond] = useState(React.createRef());

  return (
    <div className='m-2' >
      <FilePond
        onupdatefiles={(fileItems) => { props.callFile(fileItems) }}
        allowMultiple={true}
        maxFiles={1}
        server={{
          process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {

            if (file) {
              console.log('file-->', file.type);
              if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'application/msword' || file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'text/csv' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/vnd.ms-excel') {
                progress(true, 0, 1024);
                load(file)
              }
              else {
                error('oh no, invalid file, try again');
                props.callFile([])
              }
            }
          }
        }}
        one
        labelIdle={props.labels.upload}
        ref={pond}
        checkValidity={true}
        labelFileProcessingError={(err) => {
          console.log(err);
          return err.body
        }}
      />
    </div>
  );
}

export default ImageUpload;
